import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFileEdit: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="file-edit, document, cloud, sync">
      <path
        d="M5 8V3H13L19 9V21H11"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        d="M13 3.75V9H18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        d="M5.5 20.5588L4 19.0588L4 13.5588C4 12.7304 4.67157 12.0588 5.5 12.0588C6.32843 12.0588 7 12.7304 7 13.5588L7 19.0588L5.5 20.5588Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </CentralIconBase>
  );
};

export default IconFileEdit;
